import { render, staticRenderFns } from "./zonebehaviordata.vue?vue&type=template&id=12046aa8&scoped=true&"
import script from "./zonebehaviordata.vue?vue&type=script&lang=js&"
export * from "./zonebehaviordata.vue?vue&type=script&lang=js&"
import style0 from "./zonebehaviordata.vue?vue&type=style&index=0&id=12046aa8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12046aa8",
  null
  
)

export default component.exports